import React, { useMemo } from 'react';
import { View } from 'react-native';
import useColors from 'hooks/useColors';
import BorderedSquircle from 'design-system/BorderedSquircle';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
import { CardView } from './CardView';
import Spacer from './Spacer';
import Text from './Text';
import { rem } from './values';
const InfoCardWithIndex = ({ index, title, subTitle, style, withTimeline, isLast, children, noPadding, }) => {
    const colors = useColors();
    const styles = useStyles(styleSet);
    const squircleProps = useMemo(() => ({ stroke: colors.text.brand }), [colors.text.brand]);
    const content = (<View style={[styles.row, isLast && styles.rowLast, style]}>
      <View style={isLast ? styles.squircleContainerLast : null}>
        <BorderedSquircle size={24} borderStrokeProps={squircleProps}>
          <Text Text-14 Primary>
            {index}
          </Text>
        </BorderedSquircle>
        {withTimeline ? (<View style={[styles.timeline, isLast && styles.timelineLast]}/>) : null}
      </View>
      <Spacer.W16 />
      <View style={styles.flex}>
        <Text Text-16>{title}</Text>
        <Spacer h={4}/>
        {children ?? (<Text TextThin-14 Secondary>
            {subTitle}
          </Text>)}
        {withTimeline ? <Spacer h={24}/> : null}
      </View>
    </View>);
    if (withTimeline) {
        return content;
    }
    return (<CardView withPadding={!noPadding} noMarginTop>
      {content}
    </CardView>);
};
export default React.memo(InfoCardWithIndex);
const styleSet = createStyleSheets((colors) => ({
    flex: {
        flex: 1,
    },
    row: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    rowLast: {
        alignItems: 'flex-start',
    },
    squircleContainerLast: {
        flexDirection: 'column-reverse',
    },
    timeline: {
        backgroundColor: colors.elements.brand,
        width: rem(2),
        flex: 1,
        alignSelf: 'center',
    },
    timelineLast: {
        flex: 0.2,
    },
}));
